<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="运营报告审批详情"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">运营报告信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item">
          <span>申请人：</span>{{ formData.approveVO && formData.approveVO.staffName }}
        </div>
        <div class="contract-apply-item">
          <span>运营报告编号：</span>{{ formData.approveVO && formData.approveVO.flowNo }}
        </div>
        <div class="contract-apply-item">
          <span>提交时间：</span>{{ formData.approveVO && formData.approveVO.createTime | getTime }}
        </div>
        <div class="contract-apply-item" v-show="isPlatformTask=='N'"><span>所在部门：</span>{{ formData.approveVO.organisationName }}</div>
        <div class="contract-apply-item" v-show="isPlatformTask=='Y'"><span>是否传世任务：是</span></div>
        <div class="contract-apply-item"><span>是否转包任务：{{ formData.isChangeService=='Y'?'是':'否' }}</span></div>
      </div>
      <div class="contract-apply-box">
        <div
          class="contract-apply-item"
          v-if="showAcceptPackageOrganizationName"
        >
          <span>
            接包组织名称：
            {{ formData.approveVO.organisationName }}
          </span>
        </div>
        <div class="contract-apply-item"><span>{{ '企业名称：' }} </span>{{ formData.tenantName }}</div>
        <div class="contract-apply-item" 
          v-if="showSelectDepartment"
        >
          <span>选择部门：</span>
          {{ formData.organisationName }}
        </div>
        <!-- <div class="contract-apply-item">
          <span>关联质量考核流程：</span><span class="fontC-4fa1a4 c-pointer" @click="qualityDialogVisible = true" >查看</span>
        </div> -->



      </div>
      <div class="contract-apply-box">
        <div class="contract-apply-item" v-show="isPlatformTask=='N'"><span>核算月：</span>{{ formData.accountMonth }}</div>
        <div class="contract-apply-item" ><span>账单周期：</span>{{ formData.billCycleList|billFilter }}</div>
        <div class="contract-apply-item"><span>备注说明：</span>
          <span style="color: red;">{{ formData.remarks }}</span><span>{{ formData.remarks ?'': '-' }}</span>
        </div>
        <div class="contract-apply-item" v-show="formData.isContainServiceFee !== 'Y'&& isPlatformTask=='N'&&formData.researchReportType"><span>调研报告类型：</span>
          <span style="color: red;">{{codeTransformLable( formData.researchReportType ,getCodeListByKey('调研报告类型'))}}</span>
        </div>
      </div>
      <img
        v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
      <img  v-if="formData.isHedge=='Y'"  class="duichong-img" src="../../assets/images/ic_duichong.png" alt="" srcset="">

      <!-- 附件 -->
      <div class="contract-base-box" style="padding-top: 0;padding-bottom:0">
        <div class="contract-apply-file">
          <span>运营报告：</span>
          <div >
            <div v-for="(item, index) in fileList" :key="index" style="line-height:20px">
              <div class="contract-file-inform">
                <span> {{ item.fileName }}</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="onDownload(item, index)">下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contract-apply-box" v-if="formData.isChangeService=='Y'">
        <div class="contract-apply-file">
          <span>付款单：</span>
          <div v-if="paymentData.relevanceList?.length">
            <div v-for="(item, index) in paymentData.relevanceList" :key="index">
              <div class="contract-apply-file mb10">
                {{ item.text || '-' }}
                <span v-if="item.guid" class="file-preview" @click="seeDetail(item.guid)">查看详情</span>
              </div>
            </div>
          </div>
          <span v-else>-</span>
        </div>
      </div>

      <el-row :gutter="24" class="contract-apply-box"  v-show="!formData.scoreCurrentPayAmount&&isPlatformTask=='N'&&(isLastNode||formData.approveVO && formData.approveVO.approveState == 'Y')">
        <!-- 且是最后一个节点或者流程审批通过 -->
        <el-col :span="24" style="display: flex;align-items: center;">
          <div class="contract-base-title w130 " ><span class="fontC-red ">*</span>应付金额(元)
            <el-popover placement="top-bottom" popper-class="max-height:50px" content="应付金额不能大于建议应付金额" trigger="hover">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          ：
          </div>
          <div  v-if="getBtnState('approval') == 'approval'&&formData">
            <el-input
           
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            @blur="scoreCurrentPayAmount = $event.target.value"
            @input="checkScoreCurrentPayAmount(scoreCurrentPayAmount)"
            v-model.trim="scoreCurrentPayAmount"
            style="width:214px"
            placeholder="请输入"
            clearable
            size="small"
          ></el-input>
          <span v-if="scoreCurrentPayAmount" style="margin-left: 20px;">应付金额(大写)：{{ scoreCurrentPayAmount | smallToBig }}</span>
          </div>
          
          <div v-else>
            {{ formData.scoreCurrentPayAmount | numDigit}} 
            <span v-if="formData.scoreCurrentPayAmount" style="margin-left: 20px;">应付金额(大写)：{{ formData.scoreCurrentPayAmount | smallToBig }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- 质量评分 -->
      <div class="contract-apply-box">
        <div class="contract-apply-item" v-if="formData.scoreCurrentPayAmount !== null && formData.scoreCurrentPayAmount !== undefined"><span>考核金额：</span><span style="color:#ff5f1f">{{ formData.scoreCurrentPayAmount | numFmt | numDigit}}</span> 元</div>

        <div class="contract-base-box" style="margin-top:0;padding:0 4px;" v-if="servicerCheckDTO&&servicerCheckDTO.comprehensiveGrade&&isPlatformTask=='N'">
        <div class="contract-apply-file">
          <span>质量评分：</span>
          <el-popover placement="right" width="500" trigger="hover">
            <el-table :data="scoreTable">
              <el-table-column prop="name" label="评分类型" header-align="center" align="left">
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column prop="score" label="分数" header-align="center" align="right" width="150">
                <template slot-scope="scope">
                  <span>{{ Number(scope.row.value).toFixed(2)  }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="total_money_wrap" >
              <div class="total-money-list">
                <span class="total-money-title">任务金额</span><span class="total-money-num">{{ (Number(scoreTable[0].value)*Number(formData.taskSumAmount) / 100) | numFmt | numDigit }}元</span>
              </div>
              <div class="total-money-list">
                <span class="total-money-title">服务费</span><span class="total-money-num">{{ (Number(scoreTable[1].value)*Number(formData.serviceFee) / 100) | numFmt | numDigit }}元</span>
              </div>
              <div class="total-money-list">
                <span class="total-money-title">应付金额</span><span class="total-money-num">{{ (Number(scoreTable[2].value)*Number(formData.currentPayAmount) / 100) | numFmt | numDigit }}元</span>
              </div>
            </div> -->
            <span slot="reference">{{ comprehensiveGradeComputed }}</span>
          </el-popover>
        </div>
      </div>
    </div>
    </div>
    <!-- 表格内容 -->
    <div class="contract-base-box">
      <div class="back-color-fff content-main-box h100f"  style="padding: 0">
        <el-table :data="tableData" stripe border style="width: 100%" >
          <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="taskContentName"
            label="任务内容"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="200"
            fixed="left"
          >
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="taskTotal"
            label="数量"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="130"
            fixed="left"
          >
            <template slot-scope="scope">{{ scope.row.taskTotal | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="taskPrice"
            :label="formData.isContainServiceFee == 'Y' ? '单价(含服务费)' : '单价'"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
            fixed="left"
          >
            <template slot-scope="scope">{{ (scope.row.settlePercent ? '-' : scope.row.taskPrice) | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="taskPriceUnit"
            label="计价单位"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="100"
            fixed="left"
          >
              <template slot-scope="scope">{{ scope.row.settlePercent ? '-' : scope.row.taskPriceUnit }}</template>
          </el-table-column>
          <el-table-column
            prop="taskAmount"
            label="金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
            fixed="left"
          >
            <template slot-scope="scope">{{ scope.row.taskAmount | numFmt | numDigit }}</template>
          </el-table-column>
        </el-table>
        <div class="total_money_wrap">
          <div class="total-money-list">
            <span class="total-money-title">合计任务金额</span
            ><span class="total-money-num">{{ formData.taskSumAmount | numFmt | numDigit }}</span>元
          </div>
          <div class="total-money-list" v-show="formData.isContainServiceFee !== 'Y'&& isPlatformTask=='N'">
            <span class="total-money-title">平台运营服务费</span
            ><span class="total-money-num">{{ formData.serviceFee | numFmt | numDigit }}</span>元
          </div>
          <div class="total-money-list" v-show="formData.isContainServiceFee !== 'Y'&& isPlatformTask=='N'&&formData.researchReportType">
            <span class="total-money-title">数据服务费</span
            ><span class="total-money-num">{{ formData.dataServiceFee | numFmt | numDigit }}</span>元
          </div>
          <div class="total-money-list" v-show="isPlatformTask=='N'">
            <span class="total-money-title">建议应付金额</span
            ><span class="total-money-num">{{ formData.currentPayAmount | numFmt | numDigit }}</span>元
          </div>
        </div>
      </div>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="600px" top="15%">
      <el-table :data="scoreTable" style="width: 100%" v-if="isLastNode">
        <el-table-column prop="projectTaskName" label="评分类型" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="projectTaskName" label="分数" header-align="center" align="left" width="150">
          <template slot-scope="scope">
            {{Number(scope.row.value).toFixed(2) }}
            <!-- <el-input
              v-model="scope.row.value"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{6,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="12"
              placeholder="0-100"
            ></el-input> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="total_money_wrap" style="flex-flow: row-reverse;"  v-if="isLastNode">
        <div class="total-money-list">
          <span class="total-money-title">综合评分</span><span class="total-money-num">{{ Number(this.comprehensiveGrade).toFixed(2)  }}</span>
        </div>
      </div>
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <!-- 查看关联的质量考核流程 -->
    <el-dialog title="查看关联的质量考核流程" :visible.sync="qualityDialogVisible" width="900px" top="15%">
      <div class="back-color-fff content-main-box h00f">
        <el-table :data="qualityList" style="width: 100%" height="60vh">
          <el-table-column prop="staffName" label="发起人" header-align="center" align="left" width="100">
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="tenantName" label="企业名称" header-align="center" align="left" width="160">
            <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="organisationName" label="组织名称" header-align="center" align="left" width="160">
            <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="accountMonth" label="核算月" header-align="center" align="left" width="90">
            <template slot-scope="scope">{{ scope.row.accountMonth || '-' }}</template>
          </el-table-column>
          <el-table-column prop="isPrecise" label="是否精准考核" header-align="center" align="left" width="100">
            <template slot-scope="scope">{{ scope.row.isPrecise == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="peopleNum" label="人数" header-align="center" align="right" width="90">
            <template slot-scope="scope">{{ scope.row.peopleNum || 0 }}</template>
          </el-table-column>
          <el-table-column prop="totalMoney" label="考核总金额" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.totalMoney | numDigit }}元</template>
          </el-table-column>
          <!-- <el-table-column  width="100" label="操作" fixed="right" header-align="center" align="center">
            <template slot-scope="scope"><span @click="toQualityApprovalDetail(scope.row)">详情</span></template>
          </el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import Decimal from "decimal.js"
export default {
  components: {
    Title,
  },
  data() {
    return {
      //综合评分
      comprehensiveGrade:'',
      scoreCurrentPayAmount:'',
      isLastNode:false,
      flowType: '00016',
      fullscreenLoading: false,
      rejectDialogVisible: false,
      passDialogVisible: false,
      taskDialogVisible: false,
      qualityDialogVisible: false,
      approveSuggest: '',
      qualityList: [],//关联质量审批
      isPlatformTask:'',//平台专属任务
      formData: {},
      fileList: [],//文件列表
      tableData: [],//明细数据
      //流程
      srcs: '',//流程地址
      processInstanceId: '',//流程id
      iframeSh: true,//流程显示
      currentStaffGuid: null, //当前登录人guid
      pageTable: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      gradeData: [],
      servicerCheckDTO: null,
      //评分
      scoreTable: [
        {
          name: '根据流向判断市场拓展质量评分(权重55%)：',
          value: null,
        },
        {
          name: '根据运营报告判断市场拓展质量评分(权重30%)：',
          value: null,
        },
        {
          name: '根据市场飞检判断市场拓展质量评分(权重15%)：',
          value: null,
        },
      ],
      paymentData:{},
    };
  },
  filters: {
    billFilter(list) {
      let str='-'
      if(list&&list.length>0){
        str=list.join('、')
      }
      return str
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.currentOrganisationName = userinfo.organisationName;
    this.getPageDetail();
    this.getBpmnUrl();
    this.getNodeFlag();
  },
  mounted() {
    this.$nextTick(()=>{
      this.toTop()
    })
  },
  computed: {
    /**综合评分 */
    comprehensiveGradeComputed() {
      if (!this.servicerCheckDTO.comprehensiveGrade) {
        return;
      }
      // 保留两位小数 向上取整
      if (this.formData.scoreRule == 1) {
        return this.ceilToTwoDecimals(this.servicerCheckDTO.comprehensiveGrade || 0)
      }
      // 原有逻辑 四舍五入
      if (this.formData.scoreRule == 2) {
        return Number(this.servicerCheckDTO.comprehensiveGrade).toFixed(2)
      }
    },
    /**是否展示 选择部门 */
    showSelectDepartment() {
      // 是否转包任务选择 '否' && 平台专属任务 '否' &&  有值
      return (
        this.formData.isChangeService == "N" &&
        this.isPlatformTask == "N" &&
        this.formData.organisationName
      );
    },
    /**是否展示 接包组织名称 */
    showAcceptPackageOrganizationName() {
      // 是否转包任务选择 '是' && 任务包选择 '否' &&  有值
      return (
        this.formData.isChangeService == "Y" &&
        this.formData.isSelectTask == "N" &&
        this.formData.approveVO?.organisationName
      );
    },
  },
  methods: {
    seeDetail(guid) {
      // 付款单
      let url = '/downstreamPaymentDetail?guid=' + guid;
      window.open(url);
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      let parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    /** 获取付款单详情 */
    async getPaymentData() {
      const relevanceList = this.formData.settleList.map((item) => {
        // 有可能没有核算月
        const accountMonthStr = item.accountMonth?.length
          ? JSON.parse(item.accountMonth).join("、")
          : "";
        const payableStr = item.payable ? this.formatMoney(item.payable) : "";

        return {
          ...item,
          text: `${item.applyStaffName} _ ${item.tenantName}${
            accountMonthStr ? ` _ ${accountMonthStr}` : ""
          }${payableStr ? ` _ ${payableStr}(元)` : ""}`,
        };
      });
      this.paymentData = {
        ...this.paymentData,
        relevanceList: relevanceList,
      };
    },
    ceilToTwoDecimals(num) {
      const value = new Decimal(num)
      // 产品想要的效果是保留两位小数 必须向上进一
      // 比如 6.000000 向上取整应该是 是 6.00, 但是产品需要 6.01
      // 6.000001 向上取整 6.01
      // 6.000009 向上取整是 6.01
      // 6.010000 向上取整是 6.01 产品需要 6.02
      // 如果floorToTwoDecimals大于等于100，不需要加0.01
      
      // 取整后加 0.01
      const floorToTwoDecimals = value.times(100).floor().dividedBy(100)
      if (floorToTwoDecimals.greaterThanOrEqualTo(100)) {
        return floorToTwoDecimals.toFixed(2)
      }
      return floorToTwoDecimals.plus(0.01).toFixed(2)
    },
    codeTransformLable(val, list) {
      if (!val || !val.length) return '-';
      let result = [];
      if (typeof val == 'string') {
        list.forEach(item => {
          if (item.value == val) {
            result.push(item.text);
          }
        })
      } else {
        list.forEach(item => {
          val.forEach(el => {
            if (el == item.value) {
              result.push(item.text);
            }
          })
        })
      }
      return result.join('、');
    },
    checkScoreCurrentPayAmount(val){
      if(val > this.formData.currentPayAmount){
        this.scoreCurrentPayAmount = '';
      }
    },
    toTop() {
       let main = document.getElementById('el-main-upstream-settlement-management')
       main.scrollTop = 0
    },
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
    },
    //获取操作按钮显隐
    getBtnState(btnType) {
      return workFlowCommon.getBtnState(
        btnType,
        this.formData.approveVO && this.formData.approveVO.approveState,
        this.formData.approveVO && this.formData.approveVO.approveStaffGuids,
        this.currentStaffGuid,
        this.formData.bizApproveState,
      );
    },
    //查看附件
    toSee(file, index) {
      var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(file.path, file.fileName);
      }
      if (fileSuffix == 'zip' || fileSuffix == 'rar'||fileSuffix == 'tar') {
        return window.open(file.path + '?response-content-type=application/octet-stream');
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    //获取分数
    getTotalScore() {
      let score =
        this.numMulti(0.55, this.scoreTable[0].value) +
        this.numMulti(0.3, this.scoreTable[1].value) +
        this.numMulti(0.15, this.scoreTable[2].value);
      return score.toFixed(6);
    },
    // 小数精度处理
    numMulti(num1, num2) {
      if (!num2) {
        return 0;
      }
      var baseNum = 0;
      try {
        baseNum += num1.toString().split('.')[1].length;
      } catch (e) {}
      try {
        baseNum += num2.toString().split('.')[1].length;
      } catch (e) {}
      return (
        (Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', ''))) / Math.pow(10, baseNum)
      );
    },
    // //质量审批详情
    // toQualityApprovalDetail(row){
    //   let query = {
    //     guid: row.guid,
    //     approveStaffGuid: row.approveGuid,
    //     camundaInstanceId: row.camundaInstanceId,
    //     camundaDeploymentId: row.camundaDeploymentId,
    //     tenantGuid: row.tenantGuid,
    //     submitStaffGuid: row.staffGuid,
    //     submitStaffName: row.staffName,
    //   };
    //   this.$router.push({
    //     path:'/qualityApprovalDetail',
    //     query
    //   })
    // },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/operation-report/detail?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData = res.data.data;
            //平台专属
            self.isPlatformTask = self.formData.isPlatformTask;
            //获取明细数据
            self.tableData = self.formData.detailList;
            //审批id
            self.approveGuid = self.formData.approveVO && self.formData.approveVO.approveGuid;
            //文件展示
            self.fileList = self.formData.reportFile;
            self.servicerCheckDTO = self.formData.servicerCheckDTO;
            // self.getQualityList();
            //文件显示处理
            self.fileList.forEach((i) => {
              if (i.path.indexOf('.pdf' || '.PDF') > -1) {
                i.type = 'pdf';
              } else if (i.path.indexOf('.xls' || '.xlsx') > -1) {
                i.type = 'excel';
              } else {
                i.type = 'word';
              }
            });
            // 为已通过流程则显示打分
            if(self.formData.servicerCheckDTO && self.formData.approveVO && self.formData.approveVO.approveState == 'Y'){
              self.scoreTable.forEach((i,index)=>{
                if(index == 0){
                  i.value = self.servicerCheckDTO.flowGrade;
                }
                if(index == 1){
                  i.value = self.servicerCheckDTO.reportGrade;
                }
                if(index == 2){
                  i.value = self.servicerCheckDTO.marketCheckGrade;
                }
              })
            }
            if (self.formData.settleList.length) {
              self.getPaymentData()
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // //获取关联质量审批
    // getQualityList() {
    //   let self = this;
    //   self.api
    //     .postJson(
    //       `/${serverConfig.msSalesPerformService}/quality-assessment/get-pass-list?organisationGuid=${self.formData.organisationGuid}&tenantGuid=${self.formData.tenantGuid}`,
    //       self.formData.qualityCheckGuidList,
    //     )
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         self.qualityList = res.data.data || [];
    //       } else {
    //         self.$message.error(res.data.msg);
    //       }
    //     });
    // },
    //获取流程地址
    getBpmnUrl() {
      if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        console.log(this.srcs);
      } else {
        this.iframeSh = false;
      }
    },
        //是否最后一个节点
    getNodeFlag() {
      // this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      let query={
        staffGuid:userinfo.staffGuid,
        deploymentId:this.$route.query.camundaDeploymentId,
        processInstanceId:this.$route.query.camundaInstanceId,
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-assign-node`,query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.isLastNode = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
      
      // self.api.postJson(`/camunda-server/process-definition/get-process-nodes`,query).then((res) => {
      //   if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //     this.isLastNode = res.data.data;
      //     console.log('data', this.isLastNode);
      //   } else {
      //     self.$message.error(res.data.msg);
      //   }
      // });
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.approveGuid,
            flowType: self.flowType,
            approveStaffGuid: self.currentStaffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/upstreamOperationReportAdd',
        query: {
          // bizGuid: this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          productGuid:this.$route.query.productGuid
        },
      });
    },
    toPass() {
      let self = this;
      self.approveSuggest = '';
      if (this.isPlatformTask == 'Y' || !this.isLastNode||this.formData.scoreCurrentPayAmount) {
        self.passDialogVisible = true;
        return
      }
      if (this.isLastNode && !this.scoreCurrentPayAmount) {
        this.$message.error('应付金额不能为空');
        return;
      }
      let query = {
        scoreCurrentPayAmount: this.scoreCurrentPayAmount,
        guid: this.formData.guid,
      };
      self.fullscreenLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/upstream/operation-report/get-score`, query).then(res=>{
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let result =  res.data.data;
          this.comprehensiveGrade = result.comprehensiveGrade;
          self.scoreTable[0].value = result.flowGrade;//流向的市场拓展质量评分
          self.scoreTable[1].value  = result.reportGrade
          self.scoreTable[2].value  = result.marketCheckGrade
          this.dataServiceFee  = result.dataServiceFee
        } else {
          self.$message.error(res.data.msg);
        }

      })
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest = '';
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      if (!this.isLastNode||this.formData.scoreCurrentPayAmount ) {
        self.passSubmit();
        return;
      }
      try {
        this.scoreTable.forEach((item) => {
          if (!item.value) {
            throw new Error(`${item.name}不能为空`);
          }
        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      //评分
      let query = {
        operationReportGuid: this.formData.guid,
        flowGrade: Number(this.scoreTable[0].value),
        reportGrade: Number(this.scoreTable[1].value),
        marketCheckGrade: Number(this.scoreTable[2].value),
        comprehensiveGrade: this.comprehensiveGrade
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/operation-report/save-tenant-check`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.passSubmit();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //审批通过
    passSubmit() {
      let self = this;
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('审批通过！');
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('驳回成功！');
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 14px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 0 0 10px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 10px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
  z-index: 999;
}
/* 合同信息 */
.contract-base-box .el-col-12 {
  display: flex;
  line-height: 22px;
  margin-bottom: 10px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title {
  flex-shrink: 0;
  width: 160px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title {
  flex-shrink: 0;
  width: 200px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.select-task {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.duichong-img{
  position:absolute;
  top:0;
  right:0;
  width:81px;
}
</style>
